import { toUpper } from 'lodash';

// Kept free of component imports: reducers import from here, and pulling in
// addNominee.tsx from a reducer creates a circular import that leaves
// NctRoutes' CorrectionFoliosSelection component undefined.
export const kfinRelations = [
    'Brother',
    'Sister',
    'Father',
    'Mother',
    'Son',
    'Daughter',
    'Friend',
    'Mother In Law',
    'Father In Law',
    'Brother In Law',
    'Son In Law',
    'Daughter In Law',
    'Husband',
    'Wife',
    'Spouse',
    'Aunt',
    'Uncle',
    'Nephew',
    'Niece',
    'Grand Father',
    'Grand Mother',
    'Grand Son',
    'Grand Daughter',
    'Stepson',
    'Step Daughter',
    'Step Mother',
    'Step Father',
    'Cousin',
    'Religious Trust',
    'Charitable Trust',
];

export const getValidRelation = (relation: string) => {
    if (kfinRelations.map(toUpper).includes(relation.toUpperCase())) {
        return relation;
    }
    return '';
};
